module.exports = __webpack_public_path__ + "img/выписка.3c50adfa.png";